import React from 'react';
import '../../styles/coberturaNacional/ModalDistribuidoras.css';

// Importar todas las imágenes
import img1 from '../../../../icons/patrocinadores/img1.png';
import img2 from '../../../../icons/patrocinadores/img2.png';
import img3 from '../../../../icons/patrocinadores/img3.png';
import img4 from '../../../../icons/patrocinadores/img4.png';
import img5 from '../../../../icons/patrocinadores/img5.png';
import img6 from '../../../../icons/patrocinadores/img6.png';
import img7 from '../../../../icons/patrocinadores/img7.png';
import img8 from '../../../../icons/patrocinadores/img8.png';
import img9 from '../../../../icons/patrocinadores/img9.png';
import img10 from '../../../../icons/patrocinadores/img10.png';
import img11 from '../../../../icons/patrocinadores/img11.png';
import img12 from '../../../../icons/patrocinadores/img12.png';

const ModalDistribuidoras = ({ visible }) => {
  if (!visible) return null;

  const iconos = [
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
  ];

  return (
    <div className="modal-distribuidoras">
      <div className="iconos-grid">
        {iconos.map((icono, index) => (
          <div key={index} className="icono-container">
            <div className="icono-base">
              <img
                src={icono}
                alt={`Patrocinador ${index + 1}`}
                className={`icono-patrocinador ${index === 5 ? 'icono-patrocinador-grande' : ''}`}
                onError={e => {
                  // console.log(`Error cargando imagen: img${index + 1}.png`);
                  e.target.style.display = 'none';
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ModalDistribuidoras;
